export function isOrigin(value) {
    return [
        'border-box',
        'padding-box',
        'content-box',
        'initial',
        'inherit'
    ].includes(value);
}
//# sourceMappingURL=origin.js.map